import {useEffect, useState} from "react";
import {findActiveProductsWithPagination} from "../api/apiClient";

export const useActiveProducts = (page, reloadTrigger) => {
    const [activeProducts, setActiveProducts] = useState([]);
    const [activeProductsPagination, setActiveProductsPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const activeBookingsWithPagination = findActiveProductsWithPagination(page, abortController.signal);

        activeBookingsWithPagination
            .then(
                (data) => {
                    const customerProducts = data.customerProducts;
                    const pagination = data.pagination;

                    setActiveProducts(customerProducts)
                    setActiveProductsPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, reloadTrigger]);

    return {activeProducts : activeProducts, activeProductsPagination : activeProductsPagination};
};